import React from 'react';
import CampoEditable from './CampoEditable';
import { formatearFecha } from './estadosPartido';

const textoAviso = (a) => {
  const rival = a.contrincante ? ` contra ${a.contrincante}` : '';
  const dias = a.vencido
    ? `venció el ${formatearFecha(a.fechaLimite)}`
    : a.diasRestantes === 0 ? 'vence hoy' : `quedan ${a.diasRestantes} día${a.diasRestantes === 1 ? '' : 's'} (hasta el ${formatearFecha(a.fechaLimite)})`;
  return a.tipo === 'APLAZADO_POR_CONTRINCANTE'
    ? `Tu partido de la jornada ${a.jornada} (${a.modalidad})${rival} ha sido aplazado a petición del contrincante. Fecha límite para jugarlo: ${formatearFecha(a.fechaLimite)} — ${dias}.`
    : `Comunica los puntos de tu partido de la jornada ${a.jornada} (${a.modalidad})${rival}: ${dias}.`;
};

// Cabecera de la zona personal: datos del jugador, licencia/reconocimiento
// médico y avisos. Alias y correo los edita el propio jugador.
export default function CabeceraJugador({ resumen, onGuardarPerfil }) {
  const { jugador, club, licencia, avisos } = resumen;

  return (
    <section className="mz-cabecera" aria-label="Mis datos">
      <h3 className="mz-nombre">{jugador.nombre}</h3>

      <div className="mz-datos">
        <CampoEditable
          id="mz-alias" etiqueta="Alias" valor={jugador.alias} vacio="Sin alias"
          placeholder="Cómo quieres que te vean en los partidos"
          onGuardar={(alias) => onGuardarPerfil({ alias })}
        />
        <CampoEditable
          id="mz-email" etiqueta="Correo para avisos" valor={jugador.email} vacio="Sin correo: no recibirás avisos"
          placeholder="tu@correo.com" type="email"
          onGuardar={(email) => onGuardarPerfil({ email })}
        />
        <div className="mz-campo">
          <span className="mz-campo-etiqueta">Club</span>
          <span className={club ? 'mz-campo-valor' : 'mz-campo-valor mz-vacio'}>{club?.nombre ?? 'Sin club en esta temporada'}</span>
        </div>
        <div className="mz-campo">
          <span className="mz-campo-etiqueta">Licencia</span>
          {licencia ? (
            <span className="mz-campo-valor">
              Nº {licencia.numero} · caduca el {formatearFecha(licencia.fechaExpiracion)}{' '}
              {licencia.renovar
                ? <span className="chip chip-danger">Toca renovar el reconocimiento médico</span>
                : <span className="chip chip-success">Al día</span>}
            </span>
          ) : (
            <span className="mz-campo-valor mz-vacio">Sin licencia registrada</span>
          )}
        </div>
      </div>

      {avisos.length > 0 && (
        <ul className="mz-avisos" aria-label="Avisos">
          {avisos.map((a) => (
            <li key={`${a.tipo}-${a.partidoId}`} className={a.vencido ? 'mz-aviso mz-aviso-vencido' : 'mz-aviso'}>
              {textoAviso(a)}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
